module.exports = __webpack_public_path__ + "72d81bd3872497e6b9ab62924f746cac.svg";